import script from "./login-page.vue?vue&type=script&setup=true&lang=js"
export * from "./login-page.vue?vue&type=script&setup=true&lang=js"

import "./login-page.vue?vue&type=style&index=0&id=828cd126&lang=css"

const __exports__ = script;

export default __exports__